import { Bell } from "lucide-react";
import {
  Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription,
} from "@/components/ui/sheet";
import { PWA } from "@/constants/testIds/pwa";

export default function PwaPushSheet({ open, onAllow, onLater }) {
  return (
    <Sheet open={open} onOpenChange={(o) => { if (!o) onLater(); }}>
      <SheetContent
        side="bottom"
        data-testid={PWA.pushSheet}
        className="bg-brand-surface border-brand-line rounded-t-3xl"
      >
        <SheetHeader className="text-left">
          <div className="w-9 h-9 rounded-xl bg-brand-elevated text-brand-rose flex items-center justify-center mb-3">
            <Bell className="w-4 h-4" />
          </div>
          <SheetTitle className="font-display text-2xl text-brand-ink">
            Te chamo às 8h?
          </SheetTitle>
          <SheetDescription className="text-brand-ink2 text-[14px] font-ui">
            Quer que eu te cutuque todo dia às 8h com o que tem no calendário? Prometo não ser chata.
          </SheetDescription>
        </SheetHeader>
        <div className="mt-6 flex flex-col gap-2">
          <button
            type="button"
            data-testid={PWA.pushAllow}
            onClick={onAllow}
            className="w-full min-h-[44px] rounded-full bg-brand-rose hover:bg-brand-roseHover text-white text-[14px] font-ui"
          >
            Pode chamar
          </button>
          <button
            type="button"
            data-testid={PWA.pushLater}
            onClick={onLater}
            className="w-full min-h-[44px] rounded-full border border-brand-line bg-brand-elevated text-brand-ink2 hover:text-brand-ink text-[14px] font-ui"
          >
            Agora não
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
